/**
 * V70G8J — 게임대회 공지 [전체 보기]: 모든 페이지를 이어서 조회
 *
 * 서버 listGameCenterAnnouncements 는 한 번에 최대 100건(MAX_LIST_LIMIT)까지 주고 nextCursor 로 이어 준다.
 * 정렬(상단 고정 우선 → 최신순)은 서버 정렬 그대로이며, 고정 공지도 같은 목록 안에 있으므로 별도 합산 없음.
 * announcementId 기준 중복 제거. 비정상 응답(같은 커서 반복)·안전 상한에서 중단하고 남은 커서를 돌려준다.
 */
export const ANNOUNCEMENT_PAGE_MAX = 100;
export const ANNOUNCEMENT_MAX_PAGES = 50;

export interface AnnouncementPage<T> {
  announcements: T[];
  nextCursor: string | null;
}

export type FetchAnnouncementPage<T> = (req: { limit: number; cursor?: string }) => Promise<AnnouncementPage<T>>;

export async function fetchAllAnnouncements<T extends { announcementId: string }>(
  fetchPage: FetchAnnouncementPage<T>,
  opts: { pageSize?: number; maxPages?: number } = {},
): Promise<AnnouncementPage<T>> {
  const pageSize = opts.pageSize ?? ANNOUNCEMENT_PAGE_MAX;
  const maxPages = opts.maxPages ?? ANNOUNCEMENT_MAX_PAGES;
  const items: T[] = [];
  const seen = new Set<string>();
  let cursor: string | null = null;
  for (let page = 0; page < maxPages; page += 1) {
    const r: AnnouncementPage<T> = await fetchPage(cursor ? { limit: pageSize, cursor } : { limit: pageSize });
    for (const a of r.announcements || []) {
      if (seen.has(a.announcementId)) continue;
      seen.add(a.announcementId);
      items.push(a);
    }
    const next = r.nextCursor || null;
    if (!next || next === cursor) return { announcements: items, nextCursor: null };
    cursor = next;
  }
  return { announcements: items, nextCursor: cursor };
}
